import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Blogs from "./pages/Blogs";
import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";

import SsdHosting from "./pages/SsdHosting";
import WordPressHosting from "./pages/WordPressHosting";
import UnlimitedHosting from "./pages/UnlimitedHosting";
import ResellerHosting from "./pages/ResellerHosting";
import EmailHosting from "./pages/EmailHosting";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="cheap-ssd-hosting" element={<SsdHosting />} />
          <Route path="cheap-wordpress-hosting" element={<WordPressHosting />} />
          <Route path="cheap-unlimited-hosting" element={<UnlimitedHosting />} />
          <Route path="reseller-hosting" element={<ResellerHosting />} />
          <Route path="email-hosting" element={<EmailHosting />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);